import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { BaseSummaryControlDirective } from '../base/base-summary-control';
import { VraagboomEmptyResultaat } from '@models/vragenboom';

@Component({
  selector: 'app-radiobutton-list-summary',
  templateUrl: './radiobutton-list-summary.component.html',
  styleUrls: ['./radiobutton-list-summary.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class RadiobuttonListSummaryComponent extends BaseSummaryControlDirective<VraagboomEmptyResultaat> implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() { }

  getAnswer(): string {
    if (this.antwoordResultaat == null || this.antwoordResultaat.antwoorden == null || this.antwoordResultaat.antwoorden.length === 0) {
      return '';
    }

    return this.antwoordResultaat.antwoorden[0].titel;
  }
}
